import React from "react";
import ReactDOM from "react-dom";
import App from "./app";

ReactDOM.render(<App />, document.getElementById("root"));

// TEMP: Disable caching until we are ready to go live.
// import registerServiceWorker  from './registerServiceWorker';
// registerServiceWorker();
